import { EntityList } from '@/common/entityFramework/entityList/EntityList';

export const McoInvList = () => {
  const augFieldDefs = (fieldToFieldDef) => {
    // 1. Dimensions
    fieldToFieldDef.pbmId.precedence = 0;
    fieldToFieldDef.pbmId.hasName = true;

    fieldToFieldDef.ctrtId.precedence = 1;
    fieldToFieldDef.ctrtId.hasName = true;

    fieldToFieldDef.rbtPeriodId.precedence = 2;
    fieldToFieldDef.rbtPeriodId.hasName = false;

    // 2. Statuses
    fieldToFieldDef.status.precedence = 1000;
    fieldToFieldDef.valStatus.precedence = 1001;
    fieldToFieldDef.cldStatus.precedence = 1002;

    // 3. Amounts
    fieldToFieldDef.extInvAmt.precedence = 4001;
    fieldToFieldDef.incrRbtAmt.precedence = 4002;
    fieldToFieldDef.incrDispAmt.precedence = 4003;
    fieldToFieldDef.incrDueAmt.precedence = 4004;
    fieldToFieldDef.incrPaidAmt.precedence = 4005;
    fieldToFieldDef.incrIntrAmt.precedence = 4006;

    // 4. Other
    fieldToFieldDef.postmarkDate.precedence = 9000;
    fieldToFieldDef.dueDate.precedence = 9001;
    fieldToFieldDef.pymtDate.precedence = 9002;
    fieldToFieldDef.lineCount.precedence = 9003;
    fieldToFieldDef.valLineCount.precedence = 9004;
  };

  return <EntityList entity="MCO_INV" augFieldDefs={augFieldDefs} />;
};
